<template>
  <carousel-3d
    :border="0"
    :display="blocksData.length < 5 ? 3 : 5"
    :width="272"
    :height="75"
    :startIndex="activeIndex"
    :controlsVisible="true"
    :inverseScaling="1"
    :space="200"
    :minSwapeDistance="100"
    class="stat-slider-blocks"
  >
    <slide
      v-for="(item, index) in blocksData"
      :key="index"
      :index="index"
    >
      <ChartSmBlock
        :info="item"
        :isHoverable="true"
        :click="() => setActiveBlock(item.id)"
      />
    </slide>
  </carousel-3d>
</template>

<script>
import ChartSmBlock from "@/components/library/ChartSmBlock.vue";
import { Carousel3d, Slide } from 'vue-carousel-3d';

import StatisticsService from "@/services/StatisticsService";
import { mapState, mapMutations } from "vuex";
import { dateArrToObj } from "@/utils/dates";

export default {
  name: "TotalBlocks",

  components: {
    ChartSmBlock,
    Carousel3d,
    Slide,
  },

  props: {
    availableSteps: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      blocksData: null,
    };
  },

  computed: {
    ...mapState({
      statDateRange: state => state.stat.statDateRange,
      statOldDateRange: state => state.stat.statOldDateRange,
      carousel: state => state.stat.data.carousel,
      activeType: state => state.stat.activeType,
    }),

    activeIndex() {
      return this.blocksData.findIndex(i => i.id === this.$route.params.type);
    },
  },

  watch: {
    statDateRange: {
      immediate: true,
      handler() {
        this.getTotalStatistics();
      },
    },
  },

  created() {
    if (this.activeIndex == -1) this.setActiveBlock("promotions");
  },

  methods: {
    ...mapMutations({
      setStatActiveType: "setStatActiveType",
      setStatOldDateRange: "setStatOldDateRange",
      setCarousel: "setCarousel",
    }),

    setActiveBlock(type) {
      if (this.activeType !== type) {
        this.setStatActiveType(type);

        this.$router.push({
          name: "statistics-general", params: { type },
        });
      }
    },

    async getTotalStatistics() {
      if (!this.statDateRange) return;

      if (this.statOldDateRange[0] !== this.statDateRange[0] && this.statOldDateRange[1] !== this.statDateRange[1]) {
        this.setStatOldDateRange(this.statDateRange);
        try {
          this.formBlocksData(0);
          const res = await StatisticsService.getTotal(dateArrToObj(this.statDateRange));
          this.setCarousel(res);
          this.formBlocksData(res);
        } catch (e) {
          console.log(e);
          this.formBlocksData(0);
        }
      }
      else {
        this.formBlocksData(this.carousel);
      }
    },

    formBlocksData(data) {
      const { Promotions, Sms, Email, Viber, Whatsapp, Push, Notification, Wallet, WebPush, InApp, WebHook, ChatBot } = data;

      const blocksConfig = {
        promotions: {
          value: data ? Promotions : null,
          text: this.$t(`campaign.totalBlocks.start`),
          icon: "checked",
          color: "orange",
          measurement: [" коммуникация", " коммуникации", " коммуникаций"],
        },
        sms: {
          value: data ? Sms : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          icon: "sms",
          color: "blue",
          measurement: " СМС",
        },
        email: {
          value: data ? Email : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Email",
          icon: "email",
          color: "green",
        },
        viber: {
          value: data ? Viber : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Viber",
          icon: "viber",
          color: "violet",
        },
        whatsapp: {
          value: data ? Whatsapp : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " WhatsApp",
          icon: "whatsapp",
          color: "green",
        },
        push: {
          value: data ? Push : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Push",
          icon: "push",
          color: "red",
        },
        notification: {
          value: data ? Notification : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: this.$t(`campaign.totalBlocks.notification.measurement`),
          icon: "notification",
          color: "violet",
        },
        wallet: {
          value: data ? Wallet : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Push Кошелёк",
          icon: "wallet",
          color: "blue",
        },
        webpush: {
          value: data ? WebPush : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Web Push",
          icon: "webpush",
          color: "green",
        },
        inapp: {
          value: data ? InApp : null,
          text: "Отправлено за период",
          measurement: " In App",
          icon: "inapp",
          color: "violet",
        },
        webhook: {
          value: data ? WebHook : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Webhook",
          icon: "webhook",
          color: "orange",
        },
        chatbot: {
          value: data ? ChatBot : null,
          text: this.$t(`campaign.totalBlocks.sent`),
          measurement: " Чат-бот",
          icon: "chatbot",
          color: "blue",
        },
      };

      this.blocksData = this.availableSteps
        .filter(i => blocksConfig[i])
        .map(i => ({
          id: i,
          ...blocksConfig[i],
        }));
    },
  },
};
</script>

<style lang="scss">
.stat-slider-blocks {
  &.carousel-3d-container {
    margin: 0 auto;
  }

  .chart-sm-block__icon img {
    width: 70% !important;
  }

  .carousel-3d-slide {
    background: none;
    padding-top: 3px;
    padding-left: 3px;
    .chart-sm-block {
      &:hover {
        box-shadow: 0 0 5px 2px rgb(0 0 0 / 25%);
        opacity: 1;
      }
    }
  }
}
</style>
